js_number_perssons()
function js_number_perssons(){
    document.addEventListener('DOMContentLoaded', numberPersons)
}

function numberPersons() {
    const contexts = document.querySelectorAll('.js-number-persons')
    console.log(contexts[0])

    if (contexts != null) {
        init()
    }

    function init() {
        contexts.forEach(context => {
            const numbers = (context.dataset.number / 1)
            const finalNumbers = context.querySelector('.js-number-persons__number')
            setInterval( () => {
                const newNumber = Math.random() * (numbers - 10) + 10
                finalNumbers.innerHTML = parseInt(newNumber)
            }, 7000)
        })
    }
}